const ENV = {
    API_URL: process.env.REACT_APP_API_URL,
    ENV_MODE: process.env.REACT_APP_ENV,
    API_JOB_BOARD_URL:process.env.REACT_APP_JOB_BOARD_API_URL,
    ENABLE_HTTP_LOGS: (process.env.REACT_APP_ENABLE_HTTP_LOGS) === 'true',
}

export default ENV;
